<template>
  <el-dialog destroy-on-close title="采集单张发票" v-model="dialogFormVisible">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item label="分类" :label-width="formLabelWidth">
        <el-radio-group v-model="form.type" size="mini">
          <el-radio label="in">进项</el-radio>
          <el-radio label="out">销项</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分类" :label-width="formLabelWidth">
        <el-radio-group v-model="form.invoiceType" size="mini">
          <el-radio :label="1">专票</el-radio>
          <el-radio :label="2">普票</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开票日期" :label-width="formLabelWidth" prop="kprq">
        <el-date-picker size="mini" style="width:200px;" v-model="form.kprq" type="date" value-format="YYYYMMDD" placeholder="选择日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="发票代码" :label-width="formLabelWidth" prop="fpdm">
        <el-input style="width:200px" v-model="form.fpdm" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="发票号码" :label-width="formLabelWidth" prop="fphm">
        <el-input style="width:200px" v-model="form.fphm" size="mini"></el-input>
      </el-form-item>

      <el-form-item v-if="form.invoiceType == 1" label="金额" :label-width="formLabelWidth" prop="code">
        <el-input style="width:200px" v-model="form.code" size="mini"></el-input>
      </el-form-item>

      <el-form-item v-else label="校验码" :label-width="formLabelWidth" prop="code">
        <el-input style="width:200px" v-model="form.code" size="mini"></el-input>
      </el-form-item>

    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="savekp" size="mini">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { invoiceCollectionOne  } from '@/api/invoice.js'

export default {
  data(){
    return {
      dialogFormVisible: false,
      formLabelWidth: "100px",
      form: {
        invoiceType:1,
        type:'in',
        fpdm:"",
        code:"",
        fphm:"",
        kprq:"",
      },
      rules:{
        kprq: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        fpdm: [
          { required: true, message: '请填写发票代码', trigger: 'blur' }
        ],
        fphm: [
          { required: true, message: '请填写发票号码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请填写校验码/金额', trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    init(){
      this.dialogFormVisible = true
    },
    savekp(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          invoiceCollectionOne(this.form).then(res =>{
            if(res.data.msg == "success"){
              this.$qzfMessage("采集已完成")
              this.dialogFormVisible = false
              this.$emit("success")
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item{
  margin-bottom: 15px;
}
</style>